import i18next from 'i18next';
import { ReactComponent as PendingIcon } from 'assets/icons/pending.svg';
import { ReactComponent as DelayedIcon } from 'assets/icons/delayed.svg';
import { ReactComponent as ShippedIcon } from 'assets/icons/shipped.svg';
import { ReactComponent as ProcessingIcon } from 'assets/icons/processing.svg';
import { ReactComponent as CancelledIcon } from 'assets/icons/cancelled.svg';
import { ReactComponent as HoldIcon } from 'assets/icons/hold.svg';
import permissions from '../../config/permissions';
import { CUSTOM_TAGS_OPTIONS } from '../Shared/CustomTags';
import { getFormattedDate } from '../../helpers/localize';
import { INFO_PANE_PAGES } from '../../redux_store';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';

export const orderTypes = {
  SLIT: 'slit',
  SCIT: 'scit',
};

export const deprecatedScitItems = [
  { label: i18next.t('scit:buildUp46'), value: 'fourtySixDosePerUnitBuildUp' },
];

export const scitItems = [
  { label: i18next.t('scit:buildUp50'), value: 'fiftyDosePerUnitBuildUp' },
  { label: i18next.t('scit:stage1'), value: 'tenDosePerUnitStageOne' },
  { label: i18next.t('scit:stage2'), value: 'tenDosePerUnitStageTwo' },
  { label: i18next.t('scit:stage3'), value: 'tenDosePerUnitStageThree' },
  { label: i18next.t('scit:stage4'), value: 'tenDosePerUnitStageFour' },
  {
    label: i18next.t('scit:scitMaintenance'),
    value: 'twelveDosePerUnitSCITMaintenance',
  },
];

export const slitItems = [
  { label: i18next.t('slit:oneMonthLowDose'), value: 'oneMonthLowDose' },
  {
    label: i18next.t('slit:oneMonthSLITMaintenance'),
    value: 'oneMonthSLITMaintenance',
  },
];

export const allergenItems = [
  { label: i18next.t('allergens:grasses'), value: 'grasses' },
  { label: i18next.t('allergens:weeds'), value: 'weeds' },
  { label: i18next.t('allergens:trees'), value: 'trees' },
  { label: i18next.t('allergens:cat'), value: 'cat' },
  { label: i18next.t('allergens:dog'), value: 'dog' },
  { label: i18next.t('allergens:dustMites'), value: 'dustMites' },
  { label: i18next.t('allergens:cockroach'), value: 'cockroach' },
  { label: i18next.t('allergens:mold'), value: 'mold' },
];

export const allergySymptoms = [
  { label: i18next.t('allergens:runnyOrStuffyNose'), value: 'runnyOrStuffyNose' },
  { label: i18next.t('allergens:sneezing'), value: 'sneezing' },
  { label: i18next.t('allergens:itchyNose'), value: 'itchyNose' },
  { label: i18next.t('allergens:blockedNose'), value: 'blockedNose' },
  { label: i18next.t('allergens:postNasalDripDrainage'), value: 'postNasalDripDrainage' },
  { label: i18next.t('allergens:mouthBreathingSnoring'), value: 'mouthBreathingSnoring' },
  { label: i18next.t('allergens:frequentSniffling'), value: 'frequentSniffling' },
  { label: i18next.t('allergens:decreasedSmell'), value: 'decreasedSmell' },
  { label: i18next.t('allergens:headaches'), value: 'headaches' },
  { label: i18next.t('allergens:facialPressurePain'), value: 'facialPressurePain' },
  { label: i18next.t('allergens:redEyes'), value: 'redEyes' },
  { label: i18next.t('allergens:itchyEyes'), value: 'itchyEyes' },
  { label: i18next.t('allergens:wateryEyes'), value: 'wateryEyes' },
  { label: i18next.t('allergens:darkCircles'), value: 'darkCircles' },
  { label: i18next.t('allergens:swollenDryEyes'), value: 'swollenDryEyes' },
  { label: i18next.t('allergens:soreEyes'), value: 'soreEyes' },
  { label: i18next.t('allergens:rash'), value: 'rash' },
  { label: i18next.t('allergens:hives'), value: 'hives' },
  { label: i18next.t('allergens:eczema'), value: 'eczema' },
  { label: i18next.t('allergens:swelling'), value: 'swelling' },
  { label: i18next.t('allergens:itchySkin'), value: 'itchySkin' },
  { label: i18next.t('allergens:wheezing'), value: 'wheezing' },
  { label: i18next.t('allergens:coughing'), value: 'coughing' },
  { label: i18next.t('allergens:chestTightness'), value: 'chestTightness' },
  { label: i18next.t('allergens:shortnessOfBreath'), value: 'shortnessOfBreath' },
  { label: i18next.t('allergens:chronicBronchitis'), value: 'chronicBronchitis' },
  { label: i18next.t('allergens:itchyThroat'), value: 'itchyThroat' },
  { label: i18next.t('allergens:throatClearing'), value: 'throatClearing' },
  { label: i18next.t('allergens:soreThroat'), value: 'soreThroat' },
  { label: i18next.t('allergens:excessivePhlegm'), value: 'excessivePhlegm' },
  { label: i18next.t('allergens:hoarseness'), value: 'hoarseness' },
];

export const symptomsExposure = [
  { label: i18next.t('allergens:grasses'), value: 'grasses' },
  { label: i18next.t('allergens:otherPollen'), value: 'otherPollen' },
  { label: i18next.t('allergens:cat'), value: 'cat' },
  { label: i18next.t('allergens:dog'), value: 'dog' },
  { label: i18next.t('allergens:otherAnimalsOrInsects'), value: 'otherAnimalsOrInsects' },
  { label: i18next.t('allergens:dust'), value: 'dust' },
  { label: i18next.t('allergens:mold'), value: 'mold' },
  { label: i18next.t('allergens:wind'), value: 'wind' },
  { label: i18next.t('allergens:perfume'), value: 'perfume' },
  { label: i18next.t('allergens:smokePollution'), value: 'smokePollution' },
  { label: i18next.t('allergens:cleaningProducts'), value: 'cleaningProducts' },
  { label: i18next.t('allergens:certainTypesOfFood'), value: 'certainTypesOfFood' },
];

export const symptomsTimeOfYear = [
  { label: i18next.t('allergens:allYearRound'), value: 'allYearRound' },
  { label: i18next.t('allergens:spring'), value: 'spring' },
  { label: i18next.t('allergens:summer'), value: 'summer' },
  { label: i18next.t('allergens:fall'), value: 'fall' },
  { label: i18next.t('allergens:winter'), value: 'winter' },
  { label: i18next.t('allergens:theyJustStarted'), value: 'theyJustStarted' },
];

export const symptomsTimeInDay = [
  { label: i18next.t('allergens:atNight'), value: 'atNight' },
  { label: i18next.t('allergens:duringTheDay'), value: 'duringTheDay' },
  { label: i18next.t('allergens:bothNightAndDay'), value: 'bothNightAndDay' },
];

export const symptomsMostlyOccur = [
  { label: i18next.t('allergens:indoor'), value: 'indoor' },
  { label: i18next.t('allergens:outdoor'), value: 'outdoor' },
  { label: i18next.t('allergens:bothIndoorAndOutdoor'), value: 'bothIndoorAndOutdoor' },
];

export const allergyDiagnosis = [
  { label: i18next.t('allergens:allergicRhinitis'), value: 'allergicRhinitis' },
  { label: i18next.t('allergens:asthma'), value: 'asthma' },
  { label: i18next.t('allergens:allergicConjunctivitis'), value: 'allergicConjunctivitis' },
  { label: i18next.t('allergens:atopicDermatitis'), value: 'atopicDermatitis' },
];

export const examinationReveals = [
  {
    label: i18next.t('allergens:nasalAndSinusFindings'),
    value: 'nasalAndSinusFindings',
    options: [
      { label: i18next.t('allergens:rhinorrhea'), value: 'rhinorrhea' },
      { label: i18next.t('allergens:nasalCongestion'), value: 'nasalCongestion' },
      { label: i18next.t('allergens:turbinateHypertrophy'), value: 'turbinateHypertrophy' },
      { label: i18next.t('allergens:septalDeviation'), value: 'septalDeviation' },
      { label: i18next.t('allergens:postnasalDrip'), value: 'postnasalDrip' },
      { label: i18next.t('allergens:mouthBreathing'), value: 'mouthBreathing' },
      { label: i18next.t('allergens:anosmiaOrHyposmia'), value: 'anosmiaOrHyposmia' },
      { label: i18next.t('allergens:sinusTenderness'), value: 'sinusTenderness' },
      { label: i18next.t('allergens:facialErythemaOrSwelling'), value: 'facialErythemaOrSwelling' },
      { label: i18next.t('allergens:boggyNasalMucosa'), value: 'boggyNasalMucosa' },
    ],
  },
  {
    label: i18next.t('allergens:eyeFindings'),
    value: 'eyeFindings',
    options: [
      { label: i18next.t('allergens:conjunctivalInjection'), value: 'conjunctivalInjection' },
      { label: i18next.t('allergens:periorbitalEdema'), value: 'periorbitalEdema' },
      { label: i18next.t('allergens:darkCirclesUnderEyes'), value: 'darkCirclesUnderEyes' },
      { label: i18next.t('allergens:conjunctivalChemosis'), value: 'conjunctivalChemosis' },
      { label: i18next.t('allergens:blepharitis'), value: 'blepharitis' },
      { label: i18next.t('allergens:wateryEyesExcessiveLacrimation'), value: 'wateryEyes' },
      {
        label: i18next.t('allergens:allergicConjunctivitisItchy'),
        value: 'allergicConjunctivitis',
      },
    ],
  },
  {
    label: i18next.t('allergens:dermatologicalFindings'),
    value: 'dermatologicalFindings',
    options: [
      { label: i18next.t('allergens:erythematousRash'), value: 'erythematousRash' },
      { label: i18next.t('allergens:urticaria'), value: 'urticaria' },
      { label: i18next.t('allergens:lichenifiedPlaques'), value: 'lichenifiedPlaques' },
      { label: i18next.t('allergens:xerosis'), value: 'xerosis' },
      { label: i18next.t('allergens:angioedema'), value: 'angioedema' },
      { label: i18next.t('allergens:pruritus'), value: 'pruritus' },
    ],
  },
  {
    label: i18next.t('allergens:respiratoryFindings'),
    value: 'respiratoryFindings',
    options: [
      { label: i18next.t('allergens:wheezingHighPitched'), value: 'wheezing' },
      { label: i18next.t('allergens:prolongedExpiratoryPhase'), value: 'prolongedExpiratoryPhase' },
      { label: i18next.t('allergens:cracklesOrRales'), value: 'cracklesOrRales' },
      { label: i18next.t('allergens:rhonchi'), value: 'rhonchi' },
      { label: i18next.t('allergens:decreasedBreathSounds'), value: 'decreasedBreathSounds' },
      { label: i18next.t('allergens:coughingProductive'), value: 'coughing' },
      { label: i18next.t('allergens:barrelChest'), value: 'barrelChest' },
      { label: i18next.t('allergens:intercostalRetractions'), value: 'intercostalRetractions' },
    ],
  },
  {
    label: i18next.t('allergens:throatFindings'),
    value: 'throatFindings',
    options: [
      { label: i18next.t('allergens:pharyngealErythema'), value: 'pharyngealErythema' },
      {
        label: i18next.t('allergens:cobblestoningOfThePosteriorPharynx'),
        value: 'cobblestoningOfThePosteriorPharynx',
      },
      { label: i18next.t('allergens:hoarsenessObserved'), value: 'hoarseness' },
      { label: i18next.t('allergens:tonsillarHypertrophy'), value: 'tonsillarHypertrophy' },
      { label: i18next.t('allergens:lymphadenopathy'), value: 'lymphadenopathy' },
      { label: i18next.t('allergens:throatClearingObserved'), value: 'throatClearing' },
    ],
  },
];

export const FORMULA_OPTIONS = [
  { label: i18next.t('formulas:outdoor'), value: 'outdoor' },
  { label: i18next.t('formulas:indoor2'), value: 'indoorAllergenMixtureTwo' },
  { label: i18next.t('formulas:indoor3'), value: 'indoorAllergenMixtureThree' },
  { label: i18next.t('formulas:indoor4'), value: 'indoorAllergenMixtureFour' },
  { label: i18next.t('formulas:mold'), value: 'mold' },
  { label: i18next.t('formulas:environment'), value: 'environmentMixture' },
];

export const ORDER_STATUSES = {
  pending: 'pending',
  processing: 'processing',
  shipped: 'shipped',
  onHold: 'onHold',
  delayed: 'delayed',
  canceled: 'canceled',
  sending: 'sending',
  compounding: 'compounding',
};

export const ORDER_ACTIONS = {
  putOnHold: 'putOnHold',
  revertToPending: 'revertToPending',
  processManually: 'processManually',
  cancel: 'cancel',
  sendToPharmacy: 'sendToPharmacy',
  delay: 'delay',
  ship: 'ship',
};

export const orderStatusesActions = [
  {
    children: i18next.t('tables:putOnHold'),
    value: ORDER_ACTIONS.putOnHold,
    icon: <HoldIcon />,
    allowEditOrder: true,
    enabledForNonSponsors: true,
  },
  {
    children: i18next.t('tables:revertToPending'),
    value: ORDER_ACTIONS.revertToPending,
    icon: <PendingIcon />,
    allowEditOrder: true,
    enabledForNonSponsors: true,
  },
  {
    children: i18next.t('tables:processManually'),
    value: ORDER_ACTIONS.processManually,
    icon: <ProcessingIcon />,
    allowEditOrder: false,
    enabledForNonSponsors: false,
  },
  {
    children: i18next.t('tables:cancel'),
    value: ORDER_ACTIONS.cancel,
    icon: <CancelledIcon />,
    allowEditOrder: false,
    enabledForNonSponsors: true,
  },
  {
    children: i18next.t('tables:delay'),
    value: ORDER_ACTIONS.delay,
    icon: <DelayedIcon />,
    allowEditOrder: true,
    enabledForNonSponsors: false,
  },
  {
    children: i18next.t('tables:ship'),
    value: ORDER_ACTIONS.ship,
    icon: <ShippedIcon />,
    allowEditOrder: false,
    enabledForNonSponsors: false,
  },
];

export const ORDER_STATUS_OPTIONS = [
  // ToDO: edit icon, allowEditOrder and enabledForNonSponsors
  {
    label: i18next.t('tables:sending'),
    value: ORDER_STATUSES.sending,
    icon: PendingIcon,
    allowEditOrder: true,
    enabledForNonSponsors: true,
  },
  {
    label: i18next.t('tables:pending'),
    value: ORDER_STATUSES.pending,
    icon: PendingIcon,
    allowEditOrder: true,
    enabledForNonSponsors: true,
  },
  {
    label: i18next.t('tables:processing'),
    value: ORDER_STATUSES.processing,
    icon: ProcessingIcon,
    allowEditOrder: false,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:shipped'),
    value: ORDER_STATUSES.shipped,
    icon: ShippedIcon,
    allowEditOrder: false,
    enabledForNonSponsors: false,
    addDivider: true,
  },
  {
    label: i18next.t('tables:onHold'),
    value: ORDER_STATUSES.onHold,
    icon: HoldIcon,
    allowEditOrder: true,
    enabledForNonSponsors: true,
  },
  {
    label: i18next.t('tables:delayed'),
    value: ORDER_STATUSES.delayed,
    icon: DelayedIcon,
    allowEditOrder: true,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:canceled'),
    value: ORDER_STATUSES.canceled,
    icon: CancelledIcon,
    allowEditOrder: false,
    enabledForNonSponsors: true,
  },
  {
    label: i18next.t('tables:compounding'),
    value: ORDER_STATUSES.compounding,
    icon: CancelledIcon,
    allowEditOrder: false,
    enabledForNonSponsors: true,
  },
];

export const ORDER_TYPES = [...deprecatedScitItems, ...scitItems, ...slitItems];

export const CSV_FIELDS = [
  'accountCustomIdentifier',
  'organization',
  'firstName',
  'lastName',
  'dob',
  'gender',
  'allergies',
  'patientPhone',
  'patientAddress',
  'clinician',
  'npi',
  'shipTo',
  'category',
  'type',
  'formula',
  'qty',
  'geography',
  'date',
  'comments',
];

export const CSV_HEADERS = CSV_FIELDS.map((csvField) => ({
  key: csvField,
  label: i18next.t(`ordersCsv:${csvField}`),
}));

export const CSV_FILENAME = `Orders ${getFormattedDate(new Date(Date.now()))}.csv`;

export const GET_ORDER_COLUMNS = (isPatientPage) => [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'accountCustomTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 180,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    filter: {},
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'patientMrnNumber',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientFirstName'),
    accessorKey: 'patientFirstName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientLastName'),
    accessorKey: 'patientLastName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:patientDOB'),
    accessorKey: 'patientDateOfBirth',
    hidden: isPatientPage,
    enableColumnFilterModes: false,
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:orderType'),
    accessorKey: 'orderType',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:orderFormula'),
    accessorKey: 'orderFormula',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:orderDate'),
    accessorKey: 'orderDate',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:expectedDeliveryDate'),
    accessorKey: 'expectedDeliveryDate',
    disableSorting: true,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:status'),
    accessorKey: 'orderStatus',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
  },
];
